import { EquationTypeBase } from './base/equation-type-base';

export class EquationType extends EquationTypeBase { }